export class UserDetailsModel {
    name: any;
    surname: any;
    phonenumber: any;
    email: any;
    uuid?: string;
  
    constructor(obj: any) {
      this.name = obj.name;
      this.surname = obj.surname;
      this.phonenumber = obj.phonenumber;
      this.email = obj.email;
      this.uuid = obj.uuid;
    }
  }